import { useRef, useState } from "react";

const UserAppSurveyReadOnlyRow = ({ index, t, userAppSurveyItem, handleDeleteClick, oddIdx, add, setError, handleSubmit }) => {
	const [isSubmit, setIsSubmit] = useState(false);
	const [isEditMode, setIsEditMode] = useState(false);
	const canReadRef = useRef(null);
	const [isCanRead, setIsCanRead] = useState(userAppSurveyItem.canRead);
	const canWriteRef = useRef(null);
	const [isCanWrite, setIsCanWrite] = useState(userAppSurveyItem.canWrite);
	const canReviewRef = useRef(null);
	const [isCanReview, setIsCanReview] = useState(userAppSurveyItem.canReview);
	function submitComplete() {
		setIsSubmit(false);
	}

	function submitDelete(event, userAppSurveyItem) {
		setError("");
		setIsSubmit(true);
		handleDeleteClick(event, userAppSurveyItem, submitComplete);
	}

	const onResponseChange = (event) => {
		//console.log(event.target + "  " + event.target.name + " " + event.target.checked);
		const { name, id } = event.target;
		//event.preventDefault();
		//event.stopPropagation();
		if (name.startsWith("canRead_")) {
			setIsCanRead(event.target.checked);
		} else if (name.startsWith("canWrite_")) {
			setIsCanWrite(event.target.checked);
		} else if (name.startsWith("canReview_")) {
			setIsCanReview(event.target.checked);
		}
	}

	function handleEditClick(event) {
		//event.preventDefault();
		//event.stopPropagation();
		setIsSubmit(false);
		setIsEditMode(true);
	}

	function submitUpdate(event, userAppSurveyItem) {
		//event.preventDefault();
		//event.stopPropagation();
		setError("");
		setIsSubmit(true);
		let updatedValues = {
			appSurveyKey: userAppSurveyItem.appSurveyKey,
			canRead: canReadRef.current.checked,
			canWrite: canWriteRef.current.checked,
			canReview: canReviewRef.current.checked,
		};
		handleSubmit(2, updatedValues, submitUpdateComplete);
	}
	function submitUpdateComplete() {
		setIsSubmit(false);
		setIsEditMode(false);
	}
	function submitCancel(event, userAppSurveyItem) {
		//event.preventDefault();
		//event.stopPropagation();
		setError("");
		setIsCanRead(userAppSurveyItem.canRead);
		setIsCanWrite(userAppSurveyItem.canWrite);
		setIsCanReview(userAppSurveyItem.canReview);
		setIsEditMode(false);
		setIsSubmit(false);
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{userAppSurveyItem.appDisplayName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{userAppSurveyItem.surveyDisplayName}</td>
			{isEditMode ? (
				<>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
						<input type="checkbox" className="mycheckbox"
							ref={canReadRef}
							name={"canRead_" + userAppSurveyItem.appSurveyKey}
							id={"canRead_" + userAppSurveyItem.appSurveyKey}
							defaultChecked={true}
							checked={isCanRead}
							onChange={onResponseChange}
						/>
					</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
						<input type="checkbox" className="mycheckbox"
							ref={canWriteRef}
							name={"canWrite_" + userAppSurveyItem.appSurveyKey}
							id={"canWrite_" + userAppSurveyItem.appSurveyKey}
							defaultChecked={true}
							checked={isCanWrite}
							onChange={onResponseChange}
						/>
					</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
						<input type="checkbox" className="mycheckbox"
							ref={canReviewRef}
							name={"canReview_" + userAppSurveyItem.appSurveyKey}
							id={"canReview_" + userAppSurveyItem.appSurveyKey}
							defaultChecked={true}
							checked={isCanReview}
							onChange={onResponseChange}
						/>
					</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}></td>
				</>


			) : (
				<>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{""+userAppSurveyItem.canRead}</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{""+userAppSurveyItem.canWrite}</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{""+userAppSurveyItem.canReview}</td>
					<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{userAppSurveyItem.status}</td>
				</>
			)}

			<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{isEditMode ? (
					<>
						<button className={isSubmit ? "btn btn-primary btn-block me-2 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"}
							onClick={(event) => submitUpdate(event, userAppSurveyItem)}>{t("page.submit")}</button>
						<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"}
							onClick={(event) => (submitCancel(event, userAppSurveyItem))}>{t("page.cancel")}</button>
					</>
				) : (
					<>
						<button className={isSubmit ? "btn btn-primary btn-block me-2 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"}
							onClick={(event) => handleEditClick(event)}>{t("page.edit")}</button>
						<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"} onClick={(event) => submitDelete(event, userAppSurveyItem)}>
							{userAppSurveyItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
					</>
				)}

			</td>
		</tr>
	)
}
export default UserAppSurveyReadOnlyRow;